import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { UseQueryOptions } from 'react-query'
import { HTTPError } from '../../../api/fetch/decorate-fetch'
import { getOrganization } from './requests/get-organization'
import { Query } from '../../../hooks/queries'
import { Organization } from '@contrast-security-inc/base-types'

interface OrganizationQueryArgs {
  organizationUuid: string
  expandValue?: string
}

export function useOrganization(
  { organizationUuid, expandValue = '' }: OrganizationQueryArgs,
  options?: UseQueryOptions<Organization, HTTPError>
) {
  return useContrastQuery<OrganizationQueryArgs, Organization>(
    [Query.ORGANIZATION, { organizationUuid, expandValue }],
    getOrganization,
    { organizationUuid, expandValue },
    options
  )
}
